import { useCallback, useContext } from 'react';
import { createPortal } from 'react-dom';
import { Alert } from 'reactstrap';
import moment from 'moment';
import { isEmpty } from 'lodash-es';
import { appendTimeZone } from '@s20/common/util/date';
import { useJobQuery } from '../MapView/useJobQuery';
import { FormContext } from '../../../common/forms/FormElements';
import { getJobId } from '../common';
import Slideout from '../../../common/Slideout';
import { Job } from './Job';

export const MyJobs = ({ show, onClose }) => {
    const { setFieldValue } = useContext(FormContext);

    const { data: jobs, isLoading } = useJobQuery();
    const handleSelectJob = useCallback((job) => {
        setFieldValue('selectedJobId', getJobId(job));
        onClose();
    }, [setFieldValue, onClose]);

    return createPortal(
        <Slideout
            show={show}
            onClose={onClose}
            loading={isLoading}
            formTitle="My Jobs"
        >
            {isEmpty(jobs) ? (
                <Alert
                    color="primary"
                >
                    You do not have any jobs scheduled or requested for the selected day.
                </Alert>
            ) : jobs.map((job) => {
                let statusColor = job.jobRequestStatusColor;
                let statusText = job.jobRequestStatusName;

                if (job.isComplete) {
                    statusColor = 'success';
                    statusText = 'Complete';
                } else if (job.timesheetId) {
                    statusColor = 'info';
                    statusText = 'In Progress';
                }

                return (
                    <Job
                        key={job.timesheetId || job.jobId || job.id}
                        jobType={job.jobTypeName}
                        statusColor={statusColor}
                        statusText={statusText}
                        description={job.locationAddress}
                        onSelect={() => handleSelectJob(job)}
                        jobStartTime={job.jobId && appendTimeZone(moment.parseZone(job.startTime).format('h:mm A'), job.startTime, job.timeZone)}
                    />
                );
            })}
        </Slideout>,
        document.body,
    );
};